<template>
    <div class="star-rating">
        <label class="star-rating__star" :style="{'font-size':size} " v-for="rating in ratings"
               :class="{'is-selected': ((rate >= rating) && rate != null), 'is-disabled': disabled}"
               v-on:click="set(rating)" v-on:mouseover="star_over(rating)" v-on:mouseout="star_out">
            <input class="star-rating star-rating__checkbox" type="radio" :value="rating" :name="name"
                   v-model="rate" :disabled="disabled">
          <i class="fa" :class="getStarIcon(rate, rating)"></i>
        </label>
    </div>
</template>

<script>
    export default {
        name: "StarRating",
        props: {
            'name': String,
            'value': {type: Number, default: null},
            'id': String,
            'disabled': Boolean,
            'required': Boolean,
            'size': {type: String, default: "3rem"}
        },
        data: function () {
            return {
                temp_value: null,
                ratings: [1, 2, 3, 4, 5],
                rate: this.value,
                icon: "",
            };
        },
        methods: {
            /*
             * Behaviour of the stars on mouseover.
             */
            star_over: function (index) {
                if (!this.disabled) {
                    this.temp_value = this.rate;
                    return this.rate = index;
                }

            },

            /*
             * Behaviour of the stars on mouseout.
             */
            star_out: function () {
                if (!this.disabled) {
                    return this.rate = this.temp_value;
                }
            },

            /*
             * Set the rating.
             */
            set: function (value) {
                if (!this.disabled) {
                    this.temp_value = value;
                    this.$emit('changedValue', value);
                    return this.rate = value;
                }
            },

            /*
             * Calculate star icons
             */
            getStarIcon (value, rating) {
              if ( Math.floor(value) + 1 === rating && value % 1 >= 0.25 && value % 1 < 0.75 ) return "fa-star-half-o";
              if ( value != null && (value >= rating || (Math.floor(value) + 1 === rating && value % 1 >= 0.75))) return "fa-star";
              if (value + 0.25 < rating) return "fa-star-o";
            }
        },
        watch: {
          'value': function() {
            this.rate = this.value;
          }
        },
    }
</script>

<style scoped>
    .star-rating__checkbox {
        position: absolute;
        overflow: hidden;
        clip: rect(0 0 0 0);
        height: 1px;
        width: 1px;
        margin: -1px;
        padding: 0;
    }

    .star-rating__star {
        display: inline-block;
        padding: 3px;
        vertical-align: middle;
        line-height: 1;
        color: #f1c40f;
        transition: color 0.2s ease-out;
    }

    .star-rating__star:hover {
        cursor: pointer;
    }

    .star-rating__star.is-selected {

    }

    .star-rating__star.is-disabled:hover {
        cursor: default;
    }

</style>
